(function () {
  if (!window.HbElements) return;

  class HbAccordion extends HbElements.Component {
    onConnect() {
      this.items = [];
      this.build();
    }

    onDisconnect() {
      this.teardown();
      this.items = [];
    }

    teardown() {
      this.items.forEach((item) => {
        if (!item.header) return;
        item.header.removeEventListener('click', item.clickHandler);
        item.header.removeEventListener('keydown', item.keydownHandler);
      });
    }

    build() {
      this.teardown();
      const roots = [
        ...this.querySelectorAll(
          ':scope > [data-hb-accordion-item], :scope > .hb-accordion-item'
        ),
      ];

      this.allowMultiple = this.boolAttr('allowMultiple', false);
      this.openFirstByDefault = this.boolAttr('openFirstByDefault', true);

      this.items = roots.map((root, index) => {
        const header = root.querySelector('[data-accordion-header]');
        const panel = root.querySelector('[data-accordion-panel]');
        const openByDefault = root.getAttribute('data-open-by-default') === 'true';

        if (header && panel) {
          header.id = header.id || `hb-accordion-header-${this.id || 'accordion'}-${index}`;
          panel.id = panel.id || `hb-accordion-panel-${this.id || 'accordion'}-${index}`;
          header.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'region');
          panel.setAttribute('aria-labelledby', header.id);
        }

        const item = {
          root,
          header,
          panel,
          openByDefault,
          clickHandler: null,
          keydownHandler: null,
        };

        if (header) {
          item.clickHandler = (event) => this.onHeaderClick(event, item);
          item.keydownHandler = (event) => this.onHeaderKeydown(event, item);
          header.addEventListener('click', item.clickHandler);
          header.addEventListener('keydown', item.keydownHandler);
        }

        return item;
      });

      let opened = false;
      this.items.forEach((item, index) => {
        const openByDefault =
          index === 0 ? this.openFirstByDefault : item.openByDefault;
        const open = openByDefault && (this.allowMultiple || !opened);
        if (open) opened = true;
        this.setOpen(item, open);
      });
    }

    onHeaderClick(event, item) {
      if (event.target.closest('a[href]')) return;
      event.preventDefault();
      this.toggle(item);
    }

    onHeaderKeydown(event, item) {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        this.toggle(item);
        return;
      }

      const headers = this.items.filter((entry) => entry.header);
      if (!headers.length) return;

      const current = headers.indexOf(item);
      if (current < 0) return;

      let next = current;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        next = (current + 1) % headers.length;
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        next = (current - 1 + headers.length) % headers.length;
      } else if (event.key === 'Home') {
        next = 0;
      } else if (event.key === 'End') {
        next = headers.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      headers[next].header.focus();
    }

    toggle(item) {
      const open = !this.isOpen(item);

      if (open && !this.allowMultiple) {
        this.items.forEach((entry) => {
          if (entry !== item) this.setOpen(entry, false);
        });
      }

      this.setOpen(item, open);
    }

    isOpen(item) {
      return item.header
        ? item.header.getAttribute('aria-expanded') === 'true'
        : false;
    }

    setOpen(item, open) {
      if (item.header) {
        item.header.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      if (item.panel) {
        item.panel.classList.toggle('is-open', open);
        item.panel.inert = !open;
      }
      item.root.classList.toggle('is-open', open);
    }
  }

  HbElements.define('hb-accordion', HbAccordion);
})();
